import React from "react";

function SpecialPromotionPage() {
  return <div>SpecialPromotionPage</div>;
}

export default SpecialPromotionPage;
